import Vue from 'vue';
import Component from 'vue-class-component';
import * as i18next from 'i18next';
import router from 'src/router';
import * as auth from 'core/auth';
import * as api from 'core/api';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

export interface AccountWelcomeComponentModel {
    user: api.User | null;
}

@WithRender
@Component
export default class AccountWelcomeComponent extends Vue {
    $auth: auth.AuthService; // Injected in G2S.init

    model: AccountWelcomeComponentModel = {
        user: null
    }

    mounted() {
        window.document.title = i18next.t('title_welcome');

        this.loadModel();
    }

    loadModel() {
        this.$auth.getCurrentUser().then(
            (result: api.User) => {
                if (result.hasPassword) {
                    this.model.user = result;
                }
                else {
                    router.push('/account/welcome/password');
                }
            },
            () => {
                router.push('/signin');
            }
        );
    }
}
